import React from 'react';
import { useLanguage } from '../../../context/language/LanguageContext';
import { scheduleData } from '../../../utils/scheduleData';
import './Schedule.css';

const Schedule = () => {
    const { language } = useLanguage();

    return (
        <div className="daily-schedule">
            <div className="schedule-container">
                <h2 className="schedule-title">{scheduleData[language].title}</h2>

                <div className="schedule-grid">
                    {scheduleData[language].schedule.map((item, index) => (
                        <div key={index} className="schedule-item">
                            <div className="time">{item.time}</div>
                            <div className="activity">{item.activity}</div>
                        </div>
                    ))}
                </div>

                <div className="schedule-notes">
                    <h3>{language === 'en' ? 'Important Notes' : 'မှတ်ချက်'}</h3>
                    {scheduleData[language].notes.map((note, index) => (
                        <p key={index} className="note-item">{note}</p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Schedule;